import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Collapsible, Button, Icon} from 'react-materialize'
import moment from 'moment';
import Appointment from './Appointment.js'
import {removeAppointment} from '../../store/actions/appointmentActions.js'

import './Appointments.css'

class Appointments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAppointments: this.props.appointments,
      currentSort: 'none'
    }
  }
  editAppointmentHandler = (item) => {
    this.props.removeAppointment(item.id);
  }
  sortAppointments = (appointments, type) => {
    let appointmentsToSort = [...appointments];    
    switch(type) {
      case 'name':
        appointmentsToSort = appointmentsToSort.sort((a, b) => {
          let compare = 0;
          (a.client_name.toUpperCase() > b.client_name.toUpperCase()) ? compare = 1 : compare = -1
          return compare;
        });
        break;
      case 'date':
        appointmentsToSort = appointmentsToSort.sort((a, b) => {
          let compare = 0;
          const date1 = moment(a.date);
          const date2 = moment(b.date);
          (date1.isAfter(date2)) ? compare = 1 : compare = -1
          return compare;
        });
        break;
      case 'stylist':
        appointmentsToSort = appointmentsToSort.sort((a, b) => a.stylist_id - b.stylist_id);
        break;
      default:
        appointmentsToSort = appointmentsToSort.sort();
        break;
    }
    this.setState({
      currentAppointments: appointmentsToSort,
      currentSort: type
    });
  }
  render() {
    return (
      <div>
        <header className="header_default">
          <div className="header_content">
            <h1 className="white-text">All Appointments</h1>
          </div>
        </header>

        <main className="container" style={{margin: '25px auto'}}>
        <h2>Appointments</h2>
        <div className="center-align">
          <span>Sort by:</span>
          <ul>
            <Button waves="orange" className={this.state.currentSort === 'name' ? 'deep-orange darken-1' : 'amber lighten-1' } tooltip="Client Name" onClick={() => this.sortAppointments(this.props.appointments,'name')}>
              <Icon className="white-text" center>sort_by_alpha</Icon>
            </Button>
            <Button waves="orange" className={this.state.currentSort === 'date' ? 'deep-orange darken-1' : 'amber lighten-1' } tooltip="Date" onClick={() => this.sortAppointments(this.props.appointments,'date')}>
              <Icon className="white-text" center>event_note</Icon>
            </Button>
            <Button waves="orange" className={this.state.currentSort === 'stylist' ? 'deep-orange darken-1' : 'amber lighten-1' } tooltip="Stylist" onClick={() => this.sortAppointments(this.props.appointments,'stylist')}>
              <Icon className="white-text" center>content_cut</Icon>
            </Button>
          </ul>
        </div>
          <Collapsible popout>
            { this.state.currentAppointments.map(item => {
              return (
                <Appointment item={item} editAppointmentHandler={this.editAppointmentHandler} key={item.id} />
              )
            })
            }
          </Collapsible>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appointments: state.appointment.appointments
  }
}

const mapDispatchToProps = dispatch => {
  return {
    removeAppointment: (appoint_id) => dispatch(removeAppointment(appoint_id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Appointments)
